// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"290":"7a34837b","494":"32312854"}[chunkId] + ".chunk.js";
};